module.exports = __webpack_public_path__ + "static/media/gallery-16.4f707010.jpg";